// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.related-docs-container .non-web-container .file-instance {
  display: block;
  width: 100%;
  height: auto;
  padding: 20px 20px 0 20px;
  border: 2px solid #d4cfbe;
  border-left: 5px solid #b39841;
  background-color: #f4f2ea;
  margin-bottom: 10px;
}
.related-docs-container .non-web-container .file-instance .file-type-icon {
  display: inline-block;
}
.related-docs-container .non-web-container .file-instance .file-type-icon .icon {
  display: block;
  height: 48px;
  width: 40px;
  background-repeat: no-repeat;
  background-position: 50%;
}
.related-docs-container .non-web-container .file-instance .file-type-icon .icon.pdf {
  background-image: url('pdf-icon-default.4ccbd8d35aa106dc.svg');
}
.related-docs-container .non-web-container .file-instance .file-type-icon .icon.odt {
  background-image: url('odt-icon-default.ef34f06c87b19eb4.svg');
}
.related-docs-container .non-web-container .file-instance .file-type-icon .icon.doc {
  background-image: url('doc-icon-default.6a0830f6a3577bf2.svg');
}
.related-docs-container .non-web-container .file-instance .file-type-icon .icon.multi {
  background-image: url('multi-file-icon.b4c3bee5f063efc2.svg');
}
.related-docs-container .non-web-container .file-instance .file-content .content-container {
  margin-bottom: 0;
}
.related-docs-container .non-web-container .file-instance .file-content .content-container .file-name-container .file-name,
.related-docs-container .non-web-container .file-instance .file-content .content-container .file-size-container .file-name,
.related-docs-container .non-web-container .file-instance .file-content .content-container .file-name-container .file-size,
.related-docs-container .non-web-container .file-instance .file-content .content-container .file-size-container .file-size {
  display: inline-block;
  padding-right: 5px;
  max-width: 50%;
  color: #444444;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.related-docs-container .non-web-container .file-instance .file-content .content-container .file-info-container {
  margin-bottom: 0;
}
.related-docs-container .non-web-container .file-instance .buttons button {
  margin-bottom: 5px;
}
.related-docs-container .drop-area {
  display: block;
  height: 100px;
  width: 100%;
  border: 2px dashed #d4cfbe;
  border-radius: 5px;
  text-align: center;
  vertical-align: top;
  line-height: 100px;
  margin-bottom: 20px;
}
.related-docs-container .drop-area:hover .drop-text b {
  color: #b39841;
}
.related-docs-container .drop-area .drop-load {
  display: inline;
  opacity: 0;
  height: 100%;
  width: 100%;
}
.related-docs-container .drop-area .drop-load:focus {
  text-indent: -1000px;
}
.related-docs-container .drop-area p.drop-text {
  margin-top: -100px;
  line-height: 100px;
}
.related-docs-container .drop-area p.drop-text b {
  font-family: Montserrat-Light, sans-serif;
  font-weight: 300;
  text-decoration: underline;
}
.related-docs-container .drop-area p.drop-text .icon {
  display: inline-block;
  height: 24px;
  width: 30px;
  margin-bottom: 5px;
  vertical-align: middle;
  background-position: 50%;
  background-repeat: no-repeat;
}
.related-docs-container .drop-area p.drop-text .icon#cloud {
  background-image: url('cloud-upload.df255fb3b6804c85.svg');
}
.related-docs-container .row {
  margin-bottom: 20px;
}
.related-docs-container .row-1,
.related-docs-container .row-2,
.related-docs-container .row-3,
.related-docs-container .row-4,
.related-docs-container .row-5,
.related-docs-container .row-6,
.related-docs-container .row-7,
.related-docs-container .row-8,
.related-docs-container .row-9 {
  width: 100%;
  margin-bottom: 20px;
}
.related-docs-container .row-1 .text-wrapper,
.related-docs-container .row-2 .text-wrapper,
.related-docs-container .row-3 .text-wrapper,
.related-docs-container .row-4 .text-wrapper,
.related-docs-container .row-5 .text-wrapper,
.related-docs-container .row-6 .text-wrapper,
.related-docs-container .row-7 .text-wrapper,
.related-docs-container .row-8 .text-wrapper,
.related-docs-container .row-9 .text-wrapper {
  display: block !important;
}
.related-docs-container .row-1#toggle,
.related-docs-container .row-2#toggle,
.related-docs-container .row-3#toggle,
.related-docs-container .row-4#toggle,
.related-docs-container .row-5#toggle,
.related-docs-container .row-6#toggle,
.related-docs-container .row-7#toggle,
.related-docs-container .row-8#toggle,
.related-docs-container .row-9#toggle {
  height: 71px;
}
.related-docs-container .row-1 label.toggle,
.related-docs-container .row-2 label.toggle,
.related-docs-container .row-3 label.toggle,
.related-docs-container .row-4 label.toggle,
.related-docs-container .row-5 label.toggle,
.related-docs-container .row-6 label.toggle,
.related-docs-container .row-7 label.toggle,
.related-docs-container .row-8 label.toggle,
.related-docs-container .row-9 label.toggle {
  margin-top: 14.5px;
}
.related-docs-container .row-1 .toggle-text-left,
.related-docs-container .row-2 .toggle-text-left,
.related-docs-container .row-3 .toggle-text-left,
.related-docs-container .row-4 .toggle-text-left,
.related-docs-container .row-5 .toggle-text-left,
.related-docs-container .row-6 .toggle-text-left,
.related-docs-container .row-7 .toggle-text-left,
.related-docs-container .row-8 .toggle-text-left,
.related-docs-container .row-9 .toggle-text-left {
  display: inline-block;
  margin-right: 10px;
  line-height: 61px;
  vertical-align: top;
}
.related-docs-container .row-1 .toggle-text-right,
.related-docs-container .row-2 .toggle-text-right,
.related-docs-container .row-3 .toggle-text-right,
.related-docs-container .row-4 .toggle-text-right,
.related-docs-container .row-5 .toggle-text-right,
.related-docs-container .row-6 .toggle-text-right,
.related-docs-container .row-7 .toggle-text-right,
.related-docs-container .row-8 .toggle-text-right,
.related-docs-container .row-9 .toggle-text-right {
  display: inline-block;
  margin-left: 10px;
  line-height: 61px;
  vertical-align: top;
}
.non-web-container .col-lg-12 .accordion-body .row .col-lg-6:nth-of-type(1) {
  padding-right: 30px;
}
.non-web-container .col-lg-12 .accordion-body .row .col-lg-6:nth-of-type(2) {
  padding-left: 30px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/file-upload/file-upload.component.less"],"names":[],"mappings":"AAEA;EAGM,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,8BAAA;EACA,yBAAA;EACA,mBAAA;AAHN;AAPA;EAYQ,qBAAA;AAFR;AAVA;EAeU,cAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,wBAAA;AAFV;AAIU;EACE,8DAAA;AAFZ;AAKU;EACE,8DAAA;AAHZ;AAMU;EACE,8DAAA;AAJZ;AAMU;EACE,6DAAA;AAJZ;AA7BA;EAwCU,gBAAA;AARV;AAhCA;;;;EA8Cc,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AARd;AA5CA;EAyDY,gBAAA;AAVZ;AA/CA;EAgEU,kBAAA;AAdV;AAlDA;EAuEI,cAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAlBJ;AAoBI;EAGM,cAAA;AApBV;AAhEA;EA0FM,eAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAvBN;AAyBM;EACE,oBAAA;AAvBR;AAzEA;EAqGM,kBAAA;EACA,kBAAA;AAzBN;AA7EA;EAyGQ,yCAAA;EACA,gBAAA;EACA,0BAAA;AAzBR;AAlFA;EA+GQ,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;AA1BR;AA4BQ;EACE,0DAAA;AA1BV;AA9FA;EA+HI,mBAAA;AA9BJ;AAjGA;;;;;;;;;EA2II,WAAA;EACA,mBAAA;AA/BJ;AA7GA;;;;;;;;;EA+IM,yBAAA;AAvBN;AA0BI;;;;;;;;;EACE,YAAA;AAhBN;AAnIA;;;;;;;;;EAuJM,kBAAA;AATN;AA9IA;;;;;;;;;EA2JM,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAFN;AA5JA;;;;;;;;;EAkKM,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAKN;AAAA;EAKU,mBAAA;AAFV;AAHA;EAQU,kBAAA;AAFV","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.related-docs-container {\n  .non-web-container {\n    .file-instance {\n      display: block;\n      width: 100%;\n      height: auto;\n      padding: 20px 20px 0 20px;\n      border: 2px solid @primary-50;\n      border-left: 5px solid @primary-90;\n      background-color: @primary-40;\n      margin-bottom: 10px;\n      .file-type-icon {\n        display: inline-block;\n\n        .icon {\n          display: block;\n          height: 48px;\n          width: 40px;\n          background-repeat: no-repeat;\n          background-position: 50%;\n\n          &.pdf {\n            background-image: url(\"../../styles/img/pdf-icon-default.svg\");\n          }\n\n          &.odt {\n            background-image: url(\"../../styles/img/odt-icon-default.svg\");\n          }\n\n          &.doc {\n            background-image: url(\"../../styles/img/doc-icon-default.svg\");\n          }\n          &.multi {\n            background-image: url(\"../../styles/img/multi-file-icon.svg\");\n          }\n        }\n      }\n\n      .file-content {\n        .content-container {\n          margin-bottom: 0;\n\n          .file-name-container,\n          .file-size-container {\n            .file-name,\n            .file-size {\n              display: inline-block;\n              padding-right: 5px;\n              max-width: 50%;\n              color: @secondary-90;\n              text-overflow: ellipsis;\n              white-space: nowrap;\n              overflow: hidden;\n            }\n          }\n\n          .file-info-container {\n            margin-bottom: 0;\n          }\n        }\n      }\n\n      .buttons {\n        button {\n          margin-bottom: 5px;\n        }\n      }\n    }\n  }\n\n  .drop-area {\n    display: block;\n    height: 100px;\n    width: 100%;\n    border: 2px dashed @primary-50;\n    border-radius: 5px;\n    text-align: center;\n    vertical-align: top;\n    line-height: 100px;\n    margin-bottom: 20px;\n\n    &:hover {\n      .drop-text {\n        b {\n          color: @primary-90;\n        }\n      }\n    }\n\n    .drop-load {\n      display: inline;\n      opacity: 0;\n      height: 100%;\n      width: 100%;\n\n      &:focus {\n        text-indent: -1000px;\n      }\n    }\n\n    p.drop-text {\n      margin-top: -100px;\n      line-height: 100px;\n\n      b {\n        font-family: Montserrat-Light, sans-serif;\n        font-weight: 300;\n        text-decoration: underline;\n      }\n\n      .icon {\n        display: inline-block;\n        height: 24px;\n        width: 30px;\n        margin-bottom: 5px;\n        vertical-align: middle;\n        background-position: 50%;\n        background-repeat: no-repeat;\n\n        &#cloud {\n          background-image: url(\"../../styles/img/cloud-upload.svg\");\n        }\n      }\n    }\n  }\n\n  .row {\n    margin-bottom: 20px;\n  }\n\n  .row-1,\n  .row-2,\n  .row-3,\n  .row-4,\n  .row-5,\n  .row-6,\n  .row-7,\n  .row-8,\n  .row-9 {\n    width: 100%;\n    margin-bottom: 20px;\n\n    .text-wrapper {\n      display: block !important;\n    }\n\n    &#toggle {\n      height: 71px;\n    }\n\n    label.toggle {\n      margin-top: 14.5px;\n    }\n\n    .toggle-text-left {\n      display: inline-block;\n      margin-right: 10px;\n      line-height: 61px;\n      vertical-align: top;\n    }\n\n    .toggle-text-right {\n      display: inline-block;\n      margin-left: 10px;\n      line-height: 61px;\n      vertical-align: top;\n    }\n  }\n}\n\n.non-web-container {\n  .col-lg-12 {\n    .accordion-body {\n      .row {\n        .col-lg-6:nth-of-type(1) {\n          padding-right: 30px;\n        }\n        .col-lg-6:nth-of-type(2) {\n          padding-left: 30px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
